import { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { RoleContext } from '@BUP/contexts/RoleContext'
import { FINANCE } from '@BUP/constants'

/**
 * FINANCE users have no access to the home page: the app is scoped to
 * My School only. Redirect them to /schoolpage while rendering the
 * landing page untouched for every other role (design D3).
 */
const FinanceHomeGuard = ({ children }) => {
  const role = useContext(RoleContext)

  if (role?.type === FINANCE) {
    return <Navigate to='/schoolpage' replace />
  }

  return children
}

export default FinanceHomeGuard
